import { useState, useCallback, useEffect } from 'react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined, UpCircleOutlined } from '@ant-design/icons';
import '../assets/styles/gpt.scss';
import { Modal, Select, Upload, Button, Radio, Input, message, Spin } from 'antd';
import { uploadFolderModalAPI } from "../apis"
import useSuccess from "../hooks/successMessage";
import ArrowUpIcon from "../assets/images/icons/arrow_up.svg";
import { Auth } from "../libs/utilities/helpers/Auth";

const { Dragger } = Upload;
const { Option } = Select;

export const defaultFolder = [
    {
        name: "Product Brochures",
        id: "1",
        default: true,
        files: []
    },
    {
        name: "HR Processes",
        id: "3",
        default: true,
        files: []
    },
    {
        name: "Process Notes",
        id: "4",
        default: true,
        files: []
    },
    {
        name: "Financial Reports",
        id: "5",
        default: true,
        files: []
    },
    {
        name: "Others",
        id: "6",
        default: true,
        files: []
    },
]

const UploadFolderModal = ({ showModal, toggleModalVisibility, folderList, refreshFolderList, feature, departmentList, serviceId }) => {
    const dispatch = useDispatch();
    const { errorMessage, contextHolder } = useSuccess();
    const [selectedUploadFolder, setSelectedUploadFolder] = useState("");
    const [folderName, setFolderName] = useState('');
    const [radioValue, setRadioValue] = useState("file");
    const [selectedFile, setSelectedFile] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [uploadFilesName, setUploadedFilesName] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [departmentoptions, setDepartmentoptions] = useState([]);
    const [allFolder, setAllFolder] = useState(defaultFolder)
    const [isDuplicateFileError, setIsDuplicateFileError] = useState(false)
    const [duplicateFileNames, setDuplicateFileNames] = useState([]);
    const chatBotPage = useSelector((state) => state.chatBotTemplate.currentPage);
    const [uploadRequestObject, setUploadRequestObject] = useState({
        embedding_type: "e5-large-v2",
        folder_name: '',
        folder_id: '',
        type: 'file'
    });
    const allowedFormats = ['.pdf', '.doc', '.docx', ".txt"]
    const user = Auth.getUser();

    //useEffect to map the folder list
    useEffect(() => {        
        let folders = folderList.map(item => ({
            name: item.folder_name,
            id: item.folder_id,
            default: false,
            files: item.file,
            department: item.department || []  // Ensure departments are included
        }));

        let newDefaultFolder = defaultFolder.filter(item => !folders.some(existingItem => existingItem.name === item.name));
        let tempAllFolders = [...newDefaultFolder, ...folders].sort(customSort);

        setAllFolder(tempAllFolders);
        setSelectedUploadFolder(tempAllFolders[0].id);
        setUploadRequestObject(pre => ({ ...pre, folder_name: "", folder_id: tempAllFolders[0].id }));
        // Auto-select departments for the default folder
        setSelectedDepartments(tempAllFolders[0].department || []);
    }, [folderList])

    useEffect(() => {
        const mappedOptions = departmentList ?.map(dept => ({
            label: dept.department,
            value: dept.department
        }));
        setDepartmentoptions(mappedOptions);
    }, [departmentList]);


    // Putting 'Others' category at last of category list
    const customSort = (a, b) => {
        if (a.name === "Others") {
            return 1;
            // "others" comes after all other elements  
        } else if (b.name === "Others") {
            return -1;
            // "others" comes before all other elements  
        } else {
            return 0; // no change in order for other elements  
        }
    };

    const beforeUpload = (file) => {
        const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (!feature.fileFormat.includes(fileExtension)) {
            message.error(`File must be in one of the following formats: ${feature.fileFormat.join(', ')}`);
            return Upload.LIST_IGNORE;
        }
        if ((file.size / 1024 / 1024) > 100) {
            message.error('File must be smaller than 100MB!');
            return Upload.LIST_IGNORE;
        }
        const isDuplicate = selectedFile.some(existingFile => existingFile.name === file.name);
        if (isDuplicate) {
            setDuplicateFileNames((prev) => [...prev, file.name]);
            // message.error('File already selected');
            setIsDuplicateFileError(true)
            return Upload.LIST_IGNORE;
        }
        if (radioValue == "folder") {
            return true;
        }
        // If folder is selected before selecting file, check if the file is exists or not in the selected folder
        if (selectedUploadFolder) {
            const existingFileForSelectedFolder = allFolder.find(item => item.id === selectedUploadFolder).files.map(item => item.name);
            const newFiles = existingFileForSelectedFolder.some(item => item === file.name);

            if (newFiles) {
                setIsDuplicateFileError(true);
                setDuplicateFileNames(prev => [...prev, file.name])
                return Upload.LIST_IGNORE;
            }
        }
        return true;
    }

    const handleFileChange = (file) => {
        const data = file.fileList.map(item => item.originFileObj ? item.originFileObj : item)
        setSelectedFile(data)
    }

    const customRequest = ({ file, onSuccess }) => {
        if (file && file.name) {
            onSuccess("ok");
        }
    }

    const handleFileRemove = (file) => {
        setIsDuplicateFileError(false);
        setDuplicateFileNames([])
    }

    const handleFolderName = (e) => {
        setFolderName(e.target.value);
        setUploadRequestObject((pre) => {
            return { ...pre, folder_name: e.target.value }
        });
    };

    const handleRadioChange = (e) => {
        setIsDuplicateFileError(false);
        setDuplicateFileNames([])
        setRadioValue(e.target.value);
        let folder_name;
        if (e.target.value == 'file') {
            folder_name = selectedUploadFolder;
            if (selectedUploadFolder) {
                filterDuplicateFiles(selectedUploadFolder);
            }
        } else {
            folder_name = folderName;
        }
        setUploadRequestObject((pre) => {
            return { ...pre, type: e.target.value, folder_name: folder_name };
        });
    };

    const onSelectFolder = (folderId) => {
        setSelectedUploadFolder(folderId);
        setUploadRequestObject((pre) => {
            return { ...pre, folder_name: "", folder_id: folderId };
        });
        setIsDuplicateFileError(false);
        setDuplicateFileNames([])
        if (selectedFile.length > 0) {
            filterDuplicateFiles(folderId)
        }
        const selectedFolder = allFolder.find(item => item.id === folderId);
        if (selectedFolder) {
            setSelectedDepartments(selectedFolder.department || []);
        }
    };

    const filterDuplicateFiles = (folderId) => {
        const existingFileForSelectedFolder = allFolder.find(item => item.id === folderId).files.map(item => item.name);
        const data = selectedFile.filter(item => {
            if (existingFileForSelectedFolder.includes(item.name)) {
                setDuplicateFileNames(prev => [...prev, item.name])
                return false;
            } else {
                return true;
            }
        });
        if (!arraysAreEqual(data, selectedFile)) {
            setIsDuplicateFileError(true)
        }
        setSelectedFile(data)
    }

    function arraysAreEqual(array1, array2) {
        if (array1.length !== array2.length) { return false; }
        // Sort the arrays based on the serialized representation of each object  
        const sortedArray1 = array1.slice().sort((a, b) => JSON.stringify(a) > JSON.stringify(b) ? 1 : -1);
        const sortedArray2 = array2.slice().sort((a, b) => JSON.stringify(a) > JSON.stringify(b) ? 1 : -1);
        // Use every to check if each object in the sorted arrays is equal  
        return sortedArray1.every((obj, index) => JSON.stringify(obj) === JSON.stringify(sortedArray2[index]));
    }

    const handleUpload = async () => {
        setIsDuplicateFileError(false);
        setDuplicateFileNames([]);
        // setUploadedFilesName([]);
        if (selectedFile.length === 0) {
            message.warning("Please upload atleast one file.")
            return;
        }
        if (feature.departmentFolderAccess) {
            if (selectedDepartments.length === 0) {
                message.destroy();
                message.error("Please select at least one department before uploading.");
                return;
            }
        }


        let reqData;
        if (uploadRequestObject.type === 'file') {
            // uploading to the existing folder
            if (!selectedUploadFolder) {
                message.warning("Please select folder")
                return;
            }
            // check if default folder is selected
            if (defaultFolder.some(item => item.id === uploadRequestObject.folder_id)) {
                // User is trying to upload on default folder which does not exists in the server
                // Only folder name required
                reqData = {
                    file: selectedFile,
                    // embedding_type: "e5-large-v2",
                    // department: user.Department,
                    folder_name: allFolder.find(item => item.id === uploadRequestObject.folder_id).name,
                    // type: "folder"
                }
            } else {
                // User is trying to upload on folder which already exists on folder
                // Folder id = required
                reqData = {
                    file: selectedFile,
                    // embedding_type: "e5-large-v2",
                    folder_name: allFolder.find(item => item.id === uploadRequestObject.folder_id).name,
                    folder_id: uploadRequestObject.folder_id,
                    // type: uploadRequestObject.type
                    // department: user.Department,
                }
            }
        } else {
            // uploading with new folder
            if (!folderName) {
                message.warning('Please enter folder name')
                return;
            }
            reqData = {
                file: selectedFile,
                // embedding_type: "e5-large-v2",
                // department: user.Department,
                folder_name: uploadRequestObject.folder_name,
                // type: uploadRequestObject.type
            }
        }
        if (feature.departmentFolderAccess) {
            reqData.department = selectedDepartments;

        }
        try {
            message.destroy();
            setLoading(true);
            const response = await dispatch(uploadFolderModalAPI.uploadPdf({ serviceId, ...reqData }));
            if (response.payload.statusCode === 201 && response.payload.message === 'Success') {
                message.success("File upload is in progress. Document will display in the list after a successful upload");
                refreshFolderList()
                closeModal();
            }else if(response?.payload?.message == "Folder with this name already exists" && response?.payload?.statusCode == "ERR0005"){
                message.error("Folder with this name already exists");
            }else{
                message.error("Something went wrong.Please try again later!");
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const closeModal = () => {
        toggleModalVisibility();
        setSelectedFile([]);

        // clearing folder name typed by user
        setFolderName("");

        // setSelectedUploadFolder("")
        setIsDuplicateFileError(false);
        setDuplicateFileNames([])
    }

    const handleChange = (value) => {
        setSelectedDepartments(value);
    };

    return (
        <>
            <Modal
                title="Upload Documents"
                open={showModal}
                onCancel={null}
                closable={false}
                onOk={handleUpload}
                footer={[
                    <Button key="cancel" type="text" onClick={closeModal} disabled={loading}>Cancel</Button>,
                    <Button key="upload" type="primary" onClick={handleUpload} disabled={loading}>Upload</Button>,
                ]}
                width={600}
                className="upload-folder-modal"
            >
                {
                    loading ?
                        <div className="loading-content">
                            <div className="spinner">
                                <Spin indicator={<LoadingOutlined style={{ fontSize: 50, color: "#53de49" }} spin />} />
                            </div>
                            <p>File uploading. Please wait...</p>
                        </div>
                        :
                        <>
                            <Dragger
                                id="upload-dragger"
                                name="file"
                                multiple={true}
                                fileList={selectedFile}
                                accept={feature.fileFormat}
                                listType="picture"
                                beforeUpload={beforeUpload}
                                onRemove={handleFileRemove}
                                onChange={handleFileChange}
                                customRequest={customRequest}
                                className=''
                                style={{ border: '2px dashed #1890ff' }}>
                                <div className='modal-upload-dragger' onClick={() => { setIsDuplicateFileError(false); setDuplicateFileNames([]); }}>
                                    <p>Drag and drop here or</p>
                                    <button className="btn-outlined">
                                        <div className='btn-outlined-content'>
                                            <div className='text'>Upload documents </div>
                                            <img width={29} src={ArrowUpIcon} />
                                        </div>
                                    </button>
                                </div>
                            </Dragger>

                            <Radio.Group value={radioValue} onChange={handleRadioChange} className="modal-radio-group">
                                <Radio className="upload-radio" value="file">What type of document is this?</Radio>
                                <Radio value="folder" className="upload-radio">Create document type</Radio>
                            </Radio.Group>

                            <div style={{ position: "relative" }}>
                                {radioValue === "folder" ? (
                                    <>
                                        <div className='selectfolderbox2'>
                                            {/* <div className="title">Enter folder name</div> */}
                                            <Input className="folder-name-input"
                                                value={folderName}
                                                onChange={handleFolderName}
                                                placeholder="Enter document type"
                                            />
                                        </div>
                                        {
                                            feature ?.departmentFolderAccess &&
                                                <div className='selectfolderbox2'>
                                                    {/* <div className='title'>Select folder</div> */}
                                                    <Select
                                                        style={{ width: '100%', height: "auto", marginTop: "10px" }}
                                                        placeholder="Select Department"
                                                        mode="multiple"
                                                        onChange={handleChange}
                                                        options={departmentoptions}
                                                        value={selectedDepartments}
                                                        maxTagCount="responsive"
                                                    />
                                                </div>

                                    }
                                    </>
                                ) : (
                                        <>
                                            <div className='selectfolderbox2'>
                                                {/* <div className='title'>Select folder</div> */}
                                                <Select
                                                    style={{ width: '100%', height: "40px" }}
                                                    placeholder="Select Folder"
                                                    onChange={onSelectFolder}
                                                    variant="outlined"
                                                    value={selectedUploadFolder}
                                                >
                                                    {allFolder ?.map(folder => (
                                                        <Option key={folder.id} value={`${folder.id}`}>
                                                            {folder.name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            {
                                                feature.departmentFolderAccess &&
                                                <div className='selectfolderbox2'>
                                                    {/* <div className='title'>Select folder</div> */}
                                                    <Select
                                                        style={{ width: '100%', height: "auto", marginTop: "10px" }}
                                                        placeholder="Select Department"
                                                        mode="multiple"
                                                        onChange={handleChange}
                                                        options={departmentoptions}
                                                        value={selectedDepartments}
                                                        maxTagCount="responsive"
                                                    />
                                                </div>

                                            }
                                        </>
                                    )}
                                <small style={{ color: "#cc3300" }}>
                                    {isDuplicateFileError ? (duplicateFileNames.length > 0 ? 'Below duplicate files were removed' : 'Duplicate files were removed') : ""}
                                </small>
                                <div className="duplicate-files">
                                    {duplicateFileNames.map((item, index) => <small key={index}>&#x2022; {item}</small>)}
                                </div>
                            </div>

                        </>
                }
            </Modal>
        </>
    )
}

export default UploadFolderModal;